import { css } from 'styled-components';
import { getWidth } from './getWidth';
import { NumberAttr } from './types';

export const buildBreakpoint = (col: NumberAttr, breakpoint?: number) => {
  const width = getWidth(col);
  if (breakpoint) {
    return css`
      @media (min-width: ${breakpoint}px) {
        ${width};
      }
    `;
  }
  return width;
};
